document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.getElementById('ghostdata-container');
  if (!wrapper) return;

  function safe(label, fn) {
    try {
      fn();
    } catch (err) {
      console.error('[ghost-order-options] ' + label + ' failed:', err);
    }
  }

  // ---------------------------------------------------------------------
  // Special Request -> checkbox reveals the text box
  // ---------------------------------------------------------------------
  safe('special request toggle', function () {
    var specialRequestToggle = wrapper.querySelector('#special-request-toggle');
    var specialRequestWrap = wrapper.querySelector('#special-request-wrap');
    if (!specialRequestToggle || !specialRequestWrap) return;

    var toggleSpecialRequest = function () {
      specialRequestWrap.style.display = specialRequestToggle.checked ? '' : 'none';
      if (!specialRequestToggle.checked) {
        var input = specialRequestWrap.querySelector('input');
        if (input) input.value = '';
      }
    };
    specialRequestToggle.addEventListener('change', toggleSpecialRequest);
    toggleSpecialRequest();
  });

  // ---------------------------------------------------------------------
  // Delivery Method (pill selector, mandatory, no default selection)
  //   - Nothing selected  -> both date/time fields hidden
  //   - Pickup from store -> both date/time fields hidden
  //   - Courier Delivery  -> date field + time-slot field shown together
  // ---------------------------------------------------------------------
  var deliveryMethodInput = wrapper.querySelector('#delivery-method');
  var deliveryMethodError = wrapper.querySelector('[data-delivery-method-error]');

  function clearDeliveryMethodError() {
    if (deliveryMethodError) deliveryMethodError.style.display = 'none';
  }

  function deliveryMethodIsValid() {
    // If the field isn't on the page for some reason, don't block submission.
    if (!deliveryMethodInput) return true;
    return !!deliveryMethodInput.value;
  }

  safe('delivery method pills', function () {
    var pillGroup = wrapper.querySelector('[data-pill-group="delivery-method"]');
    var pickupWrap = wrapper.querySelector('#pickup-date-wrap');
    var deliveryDateWrap = wrapper.querySelector('#delivery-date-wrap');
    if (!pillGroup || !deliveryMethodInput) return;

    function toggleDeliveryFields() {
      var value = deliveryMethodInput.value;
      if (value === 'Courier Delivery') {
        if (pickupWrap) pickupWrap.style.display = '';
        if (deliveryDateWrap) deliveryDateWrap.style.display = '';
      } else {
        if (pickupWrap) pickupWrap.style.display = 'none';
        if (deliveryDateWrap) deliveryDateWrap.style.display = 'none';
      }
    }

    var pills = Array.prototype.slice.call(pillGroup.querySelectorAll('.ghost-pill'));
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        deliveryMethodInput.value = pill.dataset.pillValue;
        clearDeliveryMethodError();
        toggleDeliveryFields();
      });
    });
    toggleDeliveryFields();
  });

  // ---------------------------------------------------------------------
  // Please Choose One -> show/hide Company name (Commercial) and
  // Hospital name (Hospital)
  // ---------------------------------------------------------------------
  safe('commercial/hospital toggle', function () {
    var commercialSelect = wrapper.querySelector('#commercial-type');
    var companyNameWrap = wrapper.querySelector('#company-name-wrap');
    var hospitalNameWrap = wrapper.querySelector('#hospital-name-wrap');
    if (!commercialSelect) return;

    var toggleTypeFields = function () {
      if (companyNameWrap) {
        companyNameWrap.style.display = commercialSelect.value === 'Commercial' ? '' : 'none';
      }
      if (hospitalNameWrap) {
        hospitalNameWrap.style.display = commercialSelect.value === 'Hospital' ? '' : 'none';
      }
    };
    commercialSelect.addEventListener('change', toggleTypeFields);
    toggleTypeFields();
  });

  // ---------------------------------------------------------------------
  // Add-on checkboxes -> "Gift wrapping" property summary + live price total
  // ---------------------------------------------------------------------
  var addonCheckboxes = wrapper.querySelectorAll('.addon-checkbox');

  safe('addon totals', function () {
    var summaryInput = wrapper.querySelector('[data-addon-summary]');
    var addonTotalWrap = wrapper.querySelector('[data-addon-total]');
    var addonTotalAmount = wrapper.querySelector('[data-addon-total-amount]');

    function updateAddons() {
      var checked = Array.prototype.filter.call(addonCheckboxes, function (c) { return c.checked; });

      if (summaryInput) {
        summaryInput.value = checked.map(function (c) { return c.value; }).join(',');
      }

      var total = checked.reduce(function (sum, c) {
        return sum + (parseFloat(c.dataset.price) || 0);
      }, 0);

      if (addonTotalAmount) addonTotalAmount.textContent = '$' + total.toFixed(2);
      if (addonTotalWrap) addonTotalWrap.style.display = total > 0 ? '' : 'none';

      document.dispatchEvent(new CustomEvent('ghost:addons-changed', { detail: { total: total } }));
    }

    addonCheckboxes.forEach(function (cb) { cb.addEventListener('change', updateAddons); });
    updateAddons();
  });

  // ---------------------------------------------------------------------
  // Gift Card Message -> simple textarea, 200-char limit with live counter.
  // Required unless the customer types "NONE" (any non-empty value passes).
  // ---------------------------------------------------------------------
  var giftInput = wrapper.querySelector('#gift-card-message');
  var giftError = wrapper.querySelector('[data-gift-card-error]');

  function clearGiftError() {
    if (giftError) giftError.style.display = 'none';
  }

  function showGiftError() {
    if (giftError) giftError.style.display = '';
  }

  function giftIsValid() {
    // If the field isn't on the page for some reason, don't block submission.
    if (!giftInput) return true;
    return !!(giftInput.value && giftInput.value.trim().length > 0);
  }

  safe('gift card message counter', function () {
    var giftCharCount = wrapper.querySelector('[data-gift-card-char-count]');
    if (!giftInput) return;
    var GIFT_MAX_LENGTH = parseInt(giftInput.getAttribute('maxlength'), 10) || 200;

    function updateGiftCharCount() {
      if (!giftCharCount) return;
      var remaining = GIFT_MAX_LENGTH - giftInput.value.length;
      giftCharCount.textContent = remaining + ' Characters remaining';
    }

    giftInput.addEventListener('input', function () {
      clearGiftError();
      updateGiftCharCount();
    });
    updateGiftCharCount();
  });

  // ---------------------------------------------------------------------
  // Submit handling: block only on genuinely invalid fields, then queue
  // add-ons as separate cart line items. Wrapped defensively so a bug here
  // can never silently swallow the main "Add to cart" submission.
  // ---------------------------------------------------------------------
  var orderGroupInput = wrapper.querySelector('[data-order-group]');

  function addAddonsToCart(orderGroup, checkedAddons) {
    var items = Array.prototype.map.call(checkedAddons, function (cb) {
      return { id: cb.dataset.variantId, quantity: 1, properties: { _io_order_group: orderGroup } };
    });

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).catch(function (e) { console.error('Add-on add to cart failed', e); });
  }

  function goToCart() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    window.location.href = cartUrl;
  }

  function handleGhostOrderSubmit(evt) {
    var hasError = false;

    try {
      if (!deliveryMethodIsValid()) {
        hasError = true;
        if (deliveryMethodError) deliveryMethodError.style.display = '';
      } else {
        clearDeliveryMethodError();
      }

      if (!giftIsValid()) {
        hasError = true;
        showGiftError();
      } else {
        clearGiftError();
      }
    } catch (err) {
      console.error('[ghost-order-options] validation failed, allowing submission:', err);
      hasError = false; // never block the sale due to a script bug
    }

    if (hasError) {
      evt.preventDefault();
      evt.stopPropagation();
      return;
    }

    var checkedAddons = wrapper.querySelectorAll('.addon-checkbox:checked');

    // No add-ons selected -> nothing extra to do, let the theme's own classic
    // form submission run exactly as normal (full page reload to cart, etc).
    if (!checkedAddons.length) {
      if (orderGroupInput) orderGroupInput.value = '';
      return;
    }

    // Add-ons ARE selected. This theme submits the form as a classic
    // full-page POST (confirmed: it navigates straight to /cart with no
    // AJAX step), so there is no reliable moment to "add on" the extra
    // items afterwards. Instead we take over the whole submission:
    // stop the native submit, send the main product via fetch ourselves,
    // then the add-ons, then navigate to the cart page manually.
    evt.preventDefault();
    evt.stopPropagation();

    var form = evt.target;
    var orderGroup = Date.now().toString();
    if (orderGroupInput) orderGroupInput.value = orderGroup;

    var submitButton = form.querySelector('[type="submit"], button[name="add"]');
    if (submitButton) submitButton.disabled = true;

    addAddonsToCart(orderGroup, checkedAddons)
      .then(function () {
        return fetch(form.action || window.routes.cart_add_url, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        }).then(function (res) { return res.json(); });
      })
      .then(function () {
        goToCart();
      })
      .catch(function (err) {
        console.error('[ghost-order-options] submission failed:', err);
        if (submitButton) submitButton.disabled = false;
      });
  }

  // Try binding directly to the form if we can find one nesting the options
  // block (fastest, most predictable). This also covers themes where the
  // options block sits in a slot next to the <form> rather than inside it,
  // by falling back to a delegated, containment-checked document listener
  // that fires regardless of exactly where the block is placed in the DOM.
  var directForm = wrapper.closest('form');
  if (directForm) {
    directForm.addEventListener('submit', handleGhostOrderSubmit);
  } else {
    document.addEventListener('submit', function (evt) {
      var submittedForm = evt.target;
      if (!submittedForm || typeof submittedForm.contains !== 'function') return;
      // Only handle this if the submitted form is inside the same product
      // form component as our options block, or actually contains it.
      var container = wrapper.closest('product-form-component') || document.body;
      if (!container.contains(submittedForm) && !submittedForm.contains(wrapper)) return;
      handleGhostOrderSubmit(evt);
    }, true);
  }
});
